import { InjectionToken } from '@angular/core';

export interface ISidenavContainer {
  registerSidenav(sidenav: unknown): void;
  deregisterSidenav(sidenav: unknown): void;
  updateLayout(): void;
}

export const SIDENAV_CONTAINER = new InjectionToken<ISidenavContainer>(
  'SidenavContainer'
);
